import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.techscriptaid.voicemeetpro';

function openPlayStore() {
  const isAndroid = /android/i.test(navigator.userAgent);
  window.location.href = isAndroid
    ? 'market://details?id=com.techscriptaid.voicemeetpro'
    : PLAY_STORE_URL;
}

export default function PlayStorePrompt({ isOpen, onDone }) {
  const handleRate = () => {
    localStorage.setItem('vm_play_rated', Date.now().toString());
    onDone();
    openPlayStore();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, padding: '1rem',
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            style={{
              background: '#0f0a1e', border: '1px solid rgba(168,85,247,0.3)',
              borderRadius: '16px', padding: '2rem', maxWidth: '360px',
              width: '100%', textAlign: 'center',
            }}
            initial={{ scale: 0.88, y: 24 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.92, y: 16 }}
            transition={{ type: 'spring', stiffness: 320, damping: 28 }}
          >
            <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>⭐</div>
            <h3 style={{ color: '#fff', fontSize: '1.2rem', marginBottom: '0.5rem' }}>
              Enjoyed the meeting?
            </h3>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.9rem', marginBottom: '1.5rem', lineHeight: 1.5 }}>
              A quick rating on Google Play helps others discover VoiceMeet Pro and takes just 10 seconds.
            </p>
            <button
              onClick={handleRate}
              style={{
                width: '100%', padding: '0.75rem', borderRadius: '10px',
                background: 'linear-gradient(135deg,#a855f7,#6366f1)',
                color: '#fff', fontWeight: 700, fontSize: '1rem',
                border: 'none', cursor: 'pointer', marginBottom: '0.75rem',
              }}
            >
              Rate on Google Play
            </button>
            <button
              onClick={onDone}
              style={{
                background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)',
                fontSize: '0.85rem', cursor: 'pointer',
              }}
            >
              Maybe later
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
